import { define } from '../../define.js';
import { Avatar } from './avatar.js';
export * from './avatar.js';
define('avatar', Avatar);
